import { SET_ERROR } from '../constants/actionTypes';

export const setErrorState = (error) => ({
  type: SET_ERROR,
  error,
});
